<template>
  <v-menu left bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <svgicon
          :name="getLangIcon()"
          width="35"
          height="20"
          :original="true"
        />
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in languages" :key="index">
        <v-list-item-title @click="locale=item.key" class="lang-selector">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { setLanguage } from '@/plugins/i18n';
import '@/../static/compiled-svg/kk-flag';
import '@/../static/compiled-svg/ru-flag';

export default {
  name: 'LanguagePicker',
  data() {
    return {
      locale: localStorage.getItem('language') || process.env.VUE_APP_DEFAULT_LOCALE,
      serverUrl: process.env.ROOT_API,
    };
  },
  watch: {
    async locale(language) {
      await setLanguage(language);
    },
  },
  computed: {
    languages() {
      return this.$store.getters['global/getLanguages'];
    },
  },
  methods: {
    getLangIcon() {
      return `${this.locale}-flag`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .picker-btn {
    font-size: 14px;
    text-transform: uppercase;
    color: #ffffff;
    outline: none;
  }
  .language {
    font-size: 12px;
  }
  .lang-selector {
    cursor: pointer;
  }
</style>
